exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon[data-v-f7d66052] {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0.026042rem;\n  cursor: pointer;\n}\n.icon .icon-img[data-v-f7d66052] {\n  /* width: 90%;\n    height: 90%; */\n}\n.content[data-v-f7d66052] {\n  /* font-size: 12px; */\n}", ""]);

// exports
